export type BankAccountDropdownFilters = Record<string, string | boolean | number | undefined>;

export const bankAccountDropdownBaseQueryKey = ['bankAccountDropdown'] as const;

export const bankAccountDropdownListBaseQueryKey = [...bankAccountDropdownBaseQueryKey, 'list'] as const;

export const bankAccountDropdownListQueryKey = (
  platformId?: string,
  isSandbox?: boolean,
  query?: BankAccountDropdownFilters
) => [...bankAccountDropdownListBaseQueryKey, platformId, isSandbox, query] as const;

export const bankAccountDropdownGetQueryKey = (platformId?: string, isSandbox?: boolean, id?: string) =>
  [...bankAccountDropdownBaseQueryKey, 'get', platformId, isSandbox, id] as const;
